import { FiCheckCircle } from "react-icons/fi";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { useCopy } from "../../i18n/useCopy";

/**
 * Reasons to work with me.
 *
 * @component
 */

const WhyMe = () => {
  const t = useCopy();
  return (
  <section className="homeSection container" aria-labelledby="why-title">
    <SectionHeading eyebrow={t.sections.why.eyebrow} title={t.sections.why.title} id="why-title" />
    <ul className="whyGrid">
      {t.whyMe.map((item, i) => (
        <Reveal as="li" key={item.title} delay={i * 0.08}>
          <FiCheckCircle className="whyIcon" aria-hidden="true" />
          <div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        </Reveal>
      ))}
    </ul>
  </section>
  );
};

export default WhyMe;
